import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-client-portal-reset-password',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, MatIconModule],
  templateUrl: './client-portal-reset-password.component.html',
  styleUrls: ['./client-portal-reset-password.component.css']
})
export class ClientPortalResetPasswordComponent implements OnInit {
  token = '';
  newPassword = '';
  confirmPassword = '';
  loading = false;
  view: 'form' | 'success' | 'error' = 'form';
  errorMessage = '';
  validationError = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token') ?? '';
    if (!this.token) {
      this.view = 'error';
      this.errorMessage = 'Invalid reset link.';
    }
  }

  get passwordsMatch(): boolean {
    return this.newPassword === this.confirmPassword;
  }

  submit() {
    this.validationError = '';

    if (this.newPassword.length < 6) {
      this.validationError = 'Password must be at least 6 characters.';
      return;
    }

    if (!this.passwordsMatch) {
      this.validationError = 'Passwords do not match.';
      return;
    }

    this.loading = true;
    this.http.post('/charitycentral/ResetClientPassword', {
      token: this.token,
      newPassword: this.newPassword
    }).subscribe({
      next: () => {
        this.loading = false;
        this.view = 'success';
      },
      error: (err) => {
        this.loading = false;
        this.view = 'error';
        this.errorMessage = err.error || 'This reset link has expired or has already been used.';
      }
    });
  }

  goToLogin() {
    this.router.navigate(['/client']);
  }
}
